"use client";

import Tooltip from "@JohnLewisPartnership/jl-design-system/dist/components/tooltip/Tooltip";
import styles from "./BundleProductSpecification.module.scss";
import { RetiredStaticBundleComponent } from "../../../../types/types";
import { Attribute } from "../../../../types/prodcatBaseTypes";

type ProductAttributeToolTipProps = {
  helpText: string;
  toolTipId: string;
};

const ProductAttributeToolTip = ({
  helpText,
  toolTipId,
}: ProductAttributeToolTipProps) => {
  return (
    <div
      data-testid="bundleProduct:specification:list:label:tooltip"
      className={styles.productSpecificationListLabelToolTip}
    >
      <Tooltip id={`tooltip-${toolTipId}`} icon>
        {helpText}
      </Tooltip>
    </div>
  );
};

type ProductAttributeProps = {
  attribute: Attribute;
};

const ProductAttribute = ({ attribute }: ProductAttributeProps) => {
  return (
    <>
      <dd
        key={`${attribute.key}-label`}
        data-testid="bundleProduct:specification:list:label"
        className={styles.productSpecificationListLabel}
      >
        {attribute.displayName}
        {attribute.helpText && (
          <ProductAttributeToolTip
            helpText={attribute.helpText}
            toolTipId={attribute.key}
          />
        )}
      </dd>
      <dt
        key={`${attribute.key}-value`}
        data-testid="bundleProduct:specification:list:value"
        className={styles.productSpecificationListValue}
      >
        {attribute.values?.join(", ")}
      </dt>
    </>
  );
};

type Props = {
  bundleComponent: RetiredStaticBundleComponent;
};

export const BundleProductSpecification = ({ bundleComponent }: Props) => {
  const { attributes: primaryAttributes = [] } = bundleComponent.variant;
  const { attributes: variantAttributes = [] } =
    bundleComponent.variant.parentProduct;

  const attributes = [...primaryAttributes, ...variantAttributes];

  const sortedAttributes = attributes.sort((a, b) =>
    (!!a.displayName && a.displayName) > (!!b.displayName && b.displayName)
      ? 1
      : -1,
  );

  return (
    <>
      <dl
        data-testid="bundleProduct:specification:list"
        className={styles.productSpecificationList}
      >
        {sortedAttributes.map((attribute, index) => (
          <ProductAttribute key={`attribute-${index}`} attribute={attribute} />
        ))}
      </dl>
    </>
  );
};
